
export class DialogBoxConfiguration{
    public data!: DialogBoxData;
    public buttons!: Array<DialogBoxBouton>;
}

export class DialogBoxData {
    public title?: string;
    public text!: string;
}

export class DialogBoxBouton {
    public type!: DialogBoxBoutonTypeeEnum;
    public text: string;
    public svgIcon: string;
    public action?: (thisArg?: any) => void;
    public color?: string;
    public closeOnClick = true;
    /**
     * Valeur retournée dans le dialofRef.afterClosed() quand le bouton est cliqué.
     */
    public returnValue?: any;
    /**
     * callback pour disable le bouton, le this du composant instancié sera passé en paramètre thisArg
     */
    public disabledFn?: (thisArg?: any) => boolean;

    constructor(text: string, svgIcon: string, action?: (thisArg?: any) => void, color?: string, disabledFn?: (thisArg?: any) => boolean, closeOnClick?: boolean, returnValue?: any) {
        this.text = text;
        this.svgIcon = svgIcon;
        this.action = action;
        this.color = color;
        this.disabledFn = disabledFn;
        this.closeOnClick = closeOnClick ?? true;
        this.returnValue = returnValue;
    }
}

export enum DialogBoxBoutonTypeeEnum {
    CONFIRMER = 'CONFIRMER',
    ANNULER = 'ANNULER',
}

export class DialogBoxBoutonConfirmer extends DialogBoxBouton {
    constructor(text?: string, action?: (thisArg?: any) => void, disabledFn?: (thisArg?: any) => boolean, closeOnClick?: boolean, returnValue?: any) {
        super(text ?? 'Confirmer', 'done', action, undefined, disabledFn, closeOnClick, returnValue);
        this.type = DialogBoxBoutonTypeeEnum.CONFIRMER;
    }
}

export class DialogBoxBoutonFermer extends DialogBoxBoutonConfirmer {
    constructor(text?: string, action?: (thisArg?: any) => void, disabledFn?: (thisArg?: any) => boolean, closeOnClick?: boolean, returnValue?: any) {
        super(text ?? 'Fermer', action, disabledFn, closeOnClick ?? true, returnValue);
        this.svgIcon = 'close';
    }
}

export class DialogBoxBoutonAnnuler extends DialogBoxBouton {
    constructor(text?: string, action?: (thisArg?: any) => void, disabledFn?: (thisArg?: any) => boolean, closeOnClick?: boolean, returnValue?: any) {
        super(text ?? 'Annuler', 'cancel', action, undefined, disabledFn, closeOnClick, returnValue);
        this.type = DialogBoxBoutonTypeeEnum.ANNULER;
    }
}
